<template>
    <div class="sortable-header" 
        :class="{'sortable-header-active': active}"
        @click="$emit('click')">
        <span class="sortable-header-label"><slot></slot></span>
        <span class="sortable-header-handle">
            <template v-if="asc">
                <CaretUp />
                <CaretDownFill />
            </template>
            <template v-else>
                <CaretUpFill />
                <CaretDown />
            </template>
        </span>
    </div>
</template>
<script>
import CaretDown from "@/components/icons/CaretDown";
import CaretDownFill from "@/components/icons/CaretDownFill";
import CaretUp from "@/components/icons/CaretUp";
import CaretUpFill from "@/components/icons/CaretUpFill";

export default {
    name: 'SortableHeader',
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        asc: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        CaretDown,
        CaretDownFill,
        CaretUp,
        CaretUpFill,
    }
}
</script>
<style>
.sortable-header {
    padding: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 5px;
}
.sortable-header-label {
    display: block;
}
.sortable-header-handle {
    /* display: none; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    visibility: hidden;
    width: 9px;
}
.sortable-header-handle svg {
    width: 9px;
    height: 9px;
}

.sortable-header:hover,
.sortable-header-active {
  background-color: #f6f6f6;
}

.sortable-header:hover .sortable-header-handle,
.sortable-header-active .sortable-header-handle
{
    visibility: visible;
}
</style>